import { RequestParams, StrapiFilter } from 'strapi/types';

import { CreateSubUseCaseStrapiPage } from './types';

export const createSubUseCasePageRequestParams = (
  filter: StrapiFilter
): RequestParams<CreateSubUseCaseStrapiPage> => {
  return {
    filters: filter,
    populate: {
      sub_use_case: {
        fields: ['name', 'slug'],
      },
      cover: true,
    },
  };
};
